import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../Drawer.module.scss";
export const DrawerFooter = ({ children, ...restProps }) => (_jsx("footer", { className: styles.drawerFooter, "data-testid": "drawer-footer", ...restProps, children: children }));
DrawerFooter.displayName = "DrawerFooter";
//# sourceMappingURL=DrawerFooter.js.map